<template>
  <div class="share">
    <div class="content">
      <div class="code">{{ id }}</div>
      <div class="btn">
        <button type="button">
          <img src="../assets/images/inviteImg/btn.png" alt @click="share">
        </button>
      </div>
    </div>
    <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.'+ '点击右上角[...]'"
      :direct="'2. '+'选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
    ></Appopen>
  </div>
</template>

<script>
import {appUrlAndroid,appUrlIOS} from "../assets/js/base64"
import axios from "axios";
export default {
  name: "share",
  data() {
    return {
      userGuid: "",
      id: "",
      isAppopen:false
    };
  },
  components:{
     Appopen: () => import("../component/Appopen.vue")
  },
  created() {
     var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    let id = this.$route.params.id;
    this.id = id;
    axios({
      url:this.$interfaces.shareId,
      method: "post",
      data: { id: id },
      dataType: "json"
    })
      .then(res => {
        this.nickname = res.data.data.nickname;
        document.getElementsByTagName("title")[0].innerText = this.nickname+"邀请您来玩我是谜";
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
      share(){
         this.baseUrl='https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan'
       if (this.isAndroid) {
          window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid("100000")}`;
        } else if (this.isiOS) {
           let ua = navigator.userAgent.toLowerCase();
           if(ua.match(/QQ/i) == "qq"){
             this.isAppopen = true
           }else{
              window.location.href = appUrlIOS('100000');
           }
        }else{
             window.location.href = 'http://share.xiyacs.com/#/open'
           }
    },
  },
  
};
</script>
<style scoped>
.share {
  background: url("../assets/images/inviteImg/bg.png") no-repeat left top;
  width: 100%;
  background-size: cover;
  height: 33.35rem;
  position: relative;
}
.share .content {
  width: 11.85rem;
  height: 5.475rem;
  position: absolute;
  top: 10.5rem;
  left: 3.5rem;

}
.share .content .code {
  z-index:2;
  width: 11.85rem;
  height: 1.625rem;
  border-radius: 0.3rem;
  text-align: center;
  background:rgb(255,255,255);
  FILTER: alpha(opacity=1);
  font-family: "NotoSansHans-Regular";
  font-size: 0.75rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.625rem;
  letter-spacing: 0px;
  margin-bottom: 0.95rem;
}
.share button {
  outline: none;
  background-color:transparent;
  border:none;
  border-radius:2rem;
}
.share .btn {
  width: 10.775rem;
  height: 2.925rem;
  /* border:0.025rem solid #ccc; */
  margin: 0 auto;
  outline: none;
}
.share .btn img {
  width: 100%;
  height: 100%;
}
/* 模态框部分 */
.modial {
  position: fixed;
  width: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  height: 30.15rem;
  background-size: cover;
}
.modial .modial_in {
  padding-left:0.375rem;
  text-align: left;
  position: absolute;
  background: rgb(255,255,255);
  width: 10rem;
  height: 5.5rem;
  left: 50%;
  bottom: 30%;
  transform: translateX(-50%);
  border-radius: 0.5rem;
}
.modial .modial_in p {
  font-size: 0.75rem;
  margin-top: 0.5rem;
}
.modial .modial_in .title{
  font-weight: bold;
}

</style>

  


// WEBPACK FOOTER //
// src/components/Share.vue